import { Paragraph } from '@vimeo/iris/typography';

export default function Likes() {
  return (
    <div>
      <Paragraph size="2">
        A <em>like</em> is a video interaction where a Vimeo member indicates that they liked a{' '}
        video.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
